import {WPApi} from "../common/wp-api";

const api = new WPApi();

jQuery(document).ready(($) => {

    const $contactForm = $('#contact-form');
    const $submitButton = $('.btn-send');

    $('input[required], textarea[required]', $contactForm).on('keyup', validateForm);


    $contactForm.on('submit', async function (e) {
        e.preventDefault();
        if (!$submitButton.hasClass('disabled')) {
            $submitButton.addClass('disabled');
            let fieldsStatuses = $('input[required], textarea[required]', $contactForm).map(function () {
                return validateForm.call(this);
            }).toArray();

            if (fieldsStatuses.every(status => status)) {
                let data = getFormData($contactForm);

                let result = await api.post('sport1/v1/contact', data);
                if (result.sent) {
                    $.when($('.form-container', '.contact-us-container').fadeOut()).then(() => {
                        window.scrollTo({y: 0, behavior: 'smooth'})
                        $('.message-feedback').css('display', 'block').fadeIn();
                    });
                }
            }
        }
        return false;
    })

    function validateForm() {

        let value = $(this).val();
        let isValid = value && value.trim();
        if (!isValid) {
            $(this).prev('label').addClass('error');
        } else {
            $(this).prev('label').removeClass('error');
        }

        return isValid;
    }

});

function getFormData($form) {
    const unIndexedArray = $form.serializeArray();
    const indexedArray = {};

    $.map(unIndexedArray, function (n, i) {
        indexedArray[n['name']] = n['value'];
    });

    return indexedArray;
}